import React from "react";
import SkillItem from "./SkillItem";

function SkillSection() {
  return (
    <div className="container">
      <div className="tokyo_tm_skillbox">
        <div className="container">
          <div className="in">
            <div className="left">
              <div className="tokyo_section_title">
                <h3>Knowledge</h3>
              </div>
              <div className="tokyo_tm_skill_list">
                <ul>
                  <SkillItem title="Bootstrap, Tailwind" />
                  <SkillItem title="React" />
                  <SkillItem title="CodeIgniter, Laravel" />
                  <SkillItem title="Flask, Django" />
                  <SkillItem title="Sass, Scss" />
                  <SkillItem title="Kotlin, Dart" />
                </ul>
              </div>
            </div>
            <div className="right">
              <div className="tokyo_section_title">
                <h3>Interests</h3>
              </div>
              <div className="tokyo_tm_skill_list">
                <ul>
                  <SkillItem title="Make UI/UX Design" />
                  <SkillItem title="Create Mobile App" />
                  <SkillItem title="Create Website App" />
                  <SkillItem title="Learn Something New" />
                  <SkillItem title="Artificial Intelegence" />
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SkillSection;
